export default function ConfigureMobilePushNotifications() {
  // TODO: configure mobile push notifications, or if not on mobile, display a QR code to download the mobile app
  return <></>
}
